module.exports = __webpack_public_path__ + "static/media/roadster.d5a9867d.svg";